module.exports = __webpack_public_path__ + "img/no-data.760be70e.png";